import type { ReactNode } from 'react';
import { BankLineIcon, Slider } from 'ui';
import { type OrganizationsListFilter, useOrganizationsInfiniteQuery } from '../../queries';
import { OrganizationCard } from '../organization-card';

type P = {
  colSpan?: 10 | 7;
  controls: {
    hasTitleIcon?: boolean;
    seeAll?: { limit?: number; onClick: () => void };
    title: ReactNode;
    titleLevel?: 2 | 4;
  };
  description?: ReactNode;
  emptyState?: ReactNode;
  getPathToOrganizationDetail: (id: string) => string;
  query?: { filter?: OrganizationsListFilter };
};

const OrganizationsSlider = ({
  colSpan,
  controls: { hasTitleIcon, seeAll, title, titleLevel },
  description,
  emptyState,
  getPathToOrganizationDetail,
  query,
}: P) => {
  const { data, fetchNextPage, hasNextPage, isFetching, isLoading } = useOrganizationsInfiniteQuery({
    filter: { ...query?.filter },
    pagination: { pageSize: 4 },
  });

  const organizations = data?.pages.flat().flatMap((organizationsPaginated) => organizationsPaginated.data);
  const organizationsTotal = data?.pages[0]?.total ?? 0;

  return (
    <Slider
      colSpan={colSpan}
      controls={{
        seeAll: { limit: seeAll?.limit, onClick: seeAll?.onClick, total: organizationsTotal },
        title,
        titleIcon: hasTitleIcon ? <BankLineIcon /> : undefined,
        titleLevel,
      }}
      description={description}
      emptyState={emptyState}
      items={organizations?.map((organization) => ({
        children: (
          <OrganizationCard getPathToOrganizationDetail={getPathToOrganizationDetail} organization={organization} />
        ),
        key: `organization-${organization.id}`,
      }))}
      queryData={{
        fetchNextPage,
        hasNextPage,
        isFetching,
        isLoading,
      }}
    />
  );
};

export default OrganizationsSlider;
